/* eslint-disable */
const dev = {
  ENV: 'dev',
  API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT_URL,
  INSURANCE_BASE_URL: process.env.REACT_APP_INSURANCE_BASE_URL,
  SENTRY_DNS: process.env.REACT_APP_SENTRY_DSN,
  GCP_UPLOAD_BASE_URL: process.env.REACT_APP_GCP_UPLOAD_BASE_URL,
  SENTRY_SAMPLE_RATE: 1.0,
  MESSAGING_API_URL: '/notifications-dev'
};

const staging = {
  ENV: 'staging',
  API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT_URL,
  INSURANCE_BASE_URL: process.env.REACT_APP_INSURANCE_BASE_URL,
  SENTRY_DNS: process.env.REACT_APP_SENTRY_DSN,
  GCP_UPLOAD_BASE_URL: process.env.REACT_APP_GCP_UPLOAD_BASE_URL,
  SENTRY_SAMPLE_RATE: 1.0,
  MESSAGING_API_URL: '/notifications-staging'
};

const prod = {
  ENV: 'prod',
  API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT_URL,
  INSURANCE_BASE_URL: process.env.REACT_APP_INSURANCE_BASE_URL,
  SENTRY_DNS: process.env.REACT_APP_SENTRY_DSN,
  GCP_UPLOAD_BASE_URL: process.env.REACT_APP_GCP_UPLOAD_BASE_URL,
  SENTRY_SAMPLE_RATE: 0.1,
  MESSAGING_API_URL: '/notifications'
};

const test = {
  ENV: 'test',
  API_ENDPOINT_URL: 'https://api.test.com',
  INSURANCE_BASE_URL: process.env.REACT_APP_INSURANCE_BASE_URL,
  SENTRY_DNS: process.env.REACT_APP_SENTRY_DSN,
  GCP_UPLOAD_BASE_URL: process.env.REACT_APP_GCP_UPLOAD_BASE_URL,
  SENTRY_SAMPLE_RATE: 1.0,
  MESSAGING_API_URL: '/notifications-staging'
};

function getEnv() {
  switch (process.env.REACT_APP_ENV || process.env.NODE_ENV) {
    case 'dev':
    case 'development':
      return dev;
    case 'staging':
      return staging;
    case 'prod':
    case 'production':
      return prod;
    case 'test':
      return test;
    default:
      return dev;
  }
}

export const env = getEnv();
